import { Scaffold } from 'layouts';
import { PaginatedOrders } from 'components/Pages/Scheduling';

export const ListOrdersPage: React.FC = () => {
  return (
    <Scaffold>
      <PaginatedOrders />
    </Scaffold>
  );
};
